import React, { useState } from "react";
import { DRAWER_BACKGROUND } from "../../../../constants/styles";
import BuildingBookAssetListPanel
    from "./BuildingBookAssetListPanel";
	import BuildingBookAssetDetailsPanel
	    from "./BuildingBookAssetDetailsPanel";

export default function AssetDetailsDrawer(
{
    assetOpen,
    assetCode,
    setAssetOpen,

    assets,

    selectedAssetId,
    setSelectedAssetId,

    selectedAsset,
    setSelectedAsset
}){

  
  const [detailsOpen, setDetailsOpen] = useState(false);

  const OMNI_BLUE = "#5a9bd6";

  const MAIN_WIDTH = 420;
  const SUB_WIDTH = 880;


  return (
    <>

      {/* ================= MAIN DRAWER ================= */}
      <div style={{
        position: "fixed",
        top: "0px",
        right: assetOpen ? "0px" : "-" + MAIN_WIDTH + "px",
        width: MAIN_WIDTH,
        height: "100vh",
        background: DRAWER_BACKGROUND,
        backdropFilter: "blur(10px)",
        boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
        transition: "right 0.4s ease",
        zIndex: 350,
        color: "#fff"
      }}>

	  <div style={{ padding: "0px", height: "100%" }}>

	      <BuildingBookAssetListPanel

	          assets={assets}

	          selectedAssetId={selectedAssetId}

	          setSelectedAssetId={setSelectedAssetId}

	          setDetailsOpen={setDetailsOpen}

	      />

	  </div>
      </div>

      {/* ================= DOCUMENT DRAWER ================= */}
      <div style={{
        position: "fixed",
        top: "0px",
        right: detailsOpen ? MAIN_WIDTH + "px" : "-" + SUB_WIDTH + "px",
        width: SUB_WIDTH,
        height: "100vh",
        background: 'white',
        backdropFilter: "blur(10px)",
        boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
        transition: "right 0.4s ease",
        zIndex: 340,
        color: "blACK"
      }}>
	

	      <BuildingBookAssetDetailsPanel
	          selectedAsset={selectedAsset}
			  setDetailsOpen={setDetailsOpen}
	      />

	  
      </div>
    </>
  );
}